<div class="marketing-area">
  <ish-content-include includeId="include.basket.base.top.pagelet2-Include"></ish-content-include>
</div>

<ng-container *ngIf="basket$ | async as basket; else emptyBasket">
  <ng-container *ngIf="basket.lineItems.length; else emptyBasket">
    <ish-shopping-basket
      [basket]="basket"
      [error]="basketError$ | async"
      [loading]="basketLoading$ | async"
      (nextStep)="nextStep()"
    ></ish-shopping-basket>
  </ng-container>
</ng-container>

<ng-template #emptyBasket>
  <ish-shopping-basket-empty [error]="basketError$ | async"></ish-shopping-basket-empty>

  <ish-loading *ngIf="basketLoading$ | async"></ish-loading>
</ng-template>

<!-- DIAS PWA Feature: Save for Later -->
<custom-lazy-save-for-later></custom-lazy-save-for-later>

<ish-lazy-recently-viewed></ish-lazy-recently-viewed>

<div class="marketing-area">
  <ish-content-include includeId="include.basket.base.bottom.pagelet2-Include"></ish-content-include>
</div>
